export const TOGGLE_CONFIRMATION_LEAVING_ITINERARY = 'TOGGLE_CONFIRMATION_LEAVING_ITINERARY'

export function displayConfirmationLeavingItineraryReducer(state = false, action) {
    switch (action.type){
        case TOGGLE_CONFIRMATION_LEAVING_ITINERARY:
            return action.payload
        default: return state
    }
}